import React from "react";
import { Grid } from "@material-ui/core";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import ImgHeader from "../ImgHeader";
import { H1, H2 } from "../Headers";
import ReadDocsCard from "../cards/ReadDocsCard";
import APIDefinitionCard from "../cards/APIDefinitionCard";
import TryCodeCard from "../cards/TryCodeCard";
import WithHelperBar from "../WithHelperBar";
import AuthorizedComponent from "../api-authorization/AuthorizedComponent";
import Roles, { ExcludeRoles } from "../../models/Roles";
import { RouteComponentProps, withRouter } from "react-router";
import { selectAuth } from "../../store/auth/selectors";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { userInRoles } from "../api-authorization/AuthorizeRoute";

interface DocsInfoProps extends RouteComponentProps {
  userRoles: Array<string>;
}

const DocsInfo = (props: DocsInfoProps) => {
  const { history } = props;

  return (
    <>
      <ScrollToTopOnMount />

      <ImgHeader url="/static/img/Documentation.png" shadowOpacity={0.5}>
        <H1>
          Select a trail map
          <br /> &amp; start your expedition.
        </H1>
      </ImgHeader>
      <WithHelperBar>
        <H2>Documentation</H2>
        <Grid container spacing={3}>
          <AuthorizedComponent allowUnauthorized={true} roles={[Roles.Documentation]}>
            <ReadDocsCard />
          </AuthorizedComponent>
          <APIDefinitionCard />
          <AuthorizedComponent allowUnauthorized={true} roles={[Roles.Documentation]}>
            <TryCodeCard />
          </AuthorizedComponent>
        </Grid>
      </WithHelperBar>
    </>
  );
};

export default connect((state: IApplicationState) => {
  return {
    ...selectAuth(state),
  };
})(withRouter(DocsInfo));
